/**
 * Schémas Zod communs : identifiants, pagination, tri, filtres.
 * Référence : document 06 § 2.6.
 */
import { FILTER_OPERATORS, PAGINATION_DEFAULT_PAGE, PAGINATION_DEFAULT_PAGE_SIZE, PAGINATION_MAX_PAGE_SIZE, } from '../constants/limits.constants.js';
import { z } from 'zod';
/** Identifiant UUID (v4 ou v7) accepté en entrée. */
export const uuidSchema = z.string().uuid({ message: 'Identifiant invalide (UUID attendu).' });
/** Paramètre d'URL `:id`. */
export const idParamSchema = z.object({ id: uuidSchema });
/** Pagination : `page` ≥ 1 et `pageSize` borné à 100. */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(PAGINATION_DEFAULT_PAGE),
    pageSize: z.coerce
        .number()
        .int()
        .min(1)
        .max(PAGINATION_MAX_PAGE_SIZE)
        .default(PAGINATION_DEFAULT_PAGE_SIZE),
});
/**
 * Tri multi-champs : `-issuedAt,number`.
 * Le préfixe `-` indique un ordre décroissant.
 */
export const sortSchema = z
    .string()
    .regex(/^-?[a-zA-Z][a-zA-Z0-9]*(\s*,\s*-?[a-zA-Z][a-zA-Z0-9]*)*$/, {
    message: 'Format de tri invalide (exemple : -issuedAt,number).',
})
    .optional();
/** Recherche plein texte : 2 à 120 caractères. */
export const searchSchema = z.string().min(2).max(120).optional();
/** Sélection de champs : `id,reference,status`. */
export const fieldsSchema = z
    .string()
    .regex(/^[a-zA-Z][a-zA-Z0-9]*(\s*,\s*[a-zA-Z][a-zA-Z0-9]*)*$/, {
    message: 'Format de sélection de champs invalide (exemple : id,reference).',
})
    .optional();
/** Enrichissements demandés : `client,lines`. */
export const includeSchema = z.string().min(1).max(200).optional();
/** Clé d'idempotence obligatoire sur les écritures sensibles. */
export const idempotencyKeySchema = uuidSchema;
/** Opérateurs de filtre acceptés dans `filter[champ][op]`. */
export const filterOperatorSchema = z.enum(FILTER_OPERATORS);
/**
 * Décompose une clé de filtre `filter[champ]` ou `filter[champ][op]` en ses composants.
 * Retourne `null` si la clé n'est pas un filtre exploitable.
 */
export function parseFilterKey(key) {
    const match = /^filter\[([a-zA-Z][a-zA-Z0-9]*)\](?:\[([a-z]+)\])?$/.exec(key);
    if (match === null) {
        return null;
    }
    return { field: match[1] ?? '', operator: match[2] ?? 'eq' };
}
/** Convertit une valeur de filtre texte en liste si elle est séparée par des virgules. */
export function parseFilterValue(value) {
    return value.includes(',') ? value.split(',').map((item) => item.trim()) : value;
}
//# sourceMappingURL=common.schema.js.map